import { render } from "./EarlyAccessBanner.vue?vue&type=template&id=d267c04c"
const script = {}

import "./EarlyAccessBanner.vue?vue&type=style&index=0&id=d267c04c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__